import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchCards } from '@/lib/mock-data';
import { SearchCard } from '@/components/dashboard/search-card';
import { GlobalSearch } from '@/components/dashboard/global-search';
import { useHistoryStore } from '@/lib/store/history-store';

export default function DashboardPage() {
  const navigate = useNavigate();
  const { isSubscribed, isSubscriptionLoaded, subscriptionPlan, loadSubscriptionFromFirestore } = useHistoryStore();

  useEffect(() => {
    document.title = 'Deepcheck - Dashboard';
  }, []);

  // Load subscription from Firestore on dashboard load if not already loaded this session
  useEffect(() => {
    if (!isSubscriptionLoaded) {
      loadSubscriptionFromFirestore();
    }
  }, [isSubscriptionLoaded, loadSubscriptionFromFirestore]);

  // Get plan label from subscription plan
  const planLabel = subscriptionPlan === 'max' ? 'MAX' : 'PRO';

  const handleCardClick = (cardType: string) => {
    const routes: Record<string, string> = {
      'search-anything': '/search/anything',
      'search-by-photo': '/search/photo',
      'person-search': '/search/person',
    };

    const route = routes[cardType];
    if (route) {
      navigate(route);
    }
  };

  return (
    <main className="px-4 py-6 space-y-6">
      {/* Branding */}
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <h1 className="text-4xl font-bold text-gray-900" style={{ fontFamily: 'var(--font-archivo-black)' }}>Deepcheck</h1>
          {isSubscribed && (
            <span className="px-3 py-1 bg-green-100 text-green-700 text-sm font-bold rounded-full border border-green-200 shadow-sm">
              {planLabel}
            </span>
          )}
        </div>

        <GlobalSearch />
      </div>

      {/* Search Cards Grid */}
      <div className="grid grid-cols-2 gap-3">
        {searchCards.map((card) => (
          <div
            key={card.id}
            className={`${
              card.type === 'search-anything' ? 'col-span-2' : ''
            } h-full`}
          >
            <SearchCard
              card={card}
              onClick={() => handleCardClick(card.type)}
            />
          </div>
        ))}
      </div>
    </main>
  );
}
